import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    MotifTable,
    MotifProgressLoader,
    MotifIcon,
    MotifButton,
    MotifToggleSwitch,
} from "@ey-xd/motif-react";
import {
    MotifFormField,
    MotifLabel,
    MotifSelect,
    MotifOption,
} from "@ey-xd/motif-react";
import Input from "../../common/components/Input/Input";
import MotifTabNavigation, {
    MotifTabControl,
} from "@ey-xd/motif-react/components/tab-navigation";
import Search from "../../common/components/Search/Search";
import Toast from '../../common/components/Toast/Toast';
import DeleteModal from './DeleteModal/DeleteModal';
import {
    actionIcDelete24px,
    fileIcFileDownload24px,
    imageIcEdit24px,
    alertIcErrorOutline24px,
    actionIcHelpOutline24px,
    navigationIcArrowBack24px,
    contentIcsave24px,
} from "@ey-xd/motif-react/assets/icons";
import {  addClient, deleteClient } from '../../redux/actions/Clients/clients'
import { regions, sectors, countries, isMaliciousInput, maliciousInputErrorMsg, MAX_INPUT_LENGTH } from './constants'
import "./Clients.scss";
import { avoidXSSattack } from "utils/security";

const Clients = () => {
    const dispatch = useDispatch()
    const [searchValue, setSearchValue] = useState("");
    const [toastVisible, setToastVisible] = useState(false);
    const [toastData, setToastData] = useState<any>();
    const [showSpinner, setShowSpinner] = useState(false);
    const [currentScreen, setCurrentScreen] = useState<"" | "CLIENTS" | "ADD">(
        "CLIENTS"
    );
    const [deleteModalVisible, setDeleteModalVisible] = useState(false)
    const [deleteItemId, setDeleteItemId] = useState(-1)

    const clients = useSelector((state: any) => state?.clients?.data || []);

    const [filteredData, setFilteredData] = useState([
        {
            id: 1,
            name: "Client 1",
            status: 'Active',
            dateCreated: '2024-10-29 10:24:10.120000',
            dateModified: '2024-10-29 10:24:10.120000',
        }
    ]);

    // Form Fields
    const [userDetails, setUserDetails] = useState<any>({});

    useEffect(() => {
        if(clients.length) {
            setFilteredData(clients);
        }
    }, [clients])

    // useEffect(() => {
    //     setShowSpinner(true)
    //     dispatch(getClients()).then(() => setShowSpinner(false))
    // }, [])

    const handleSearch = (e: any) => {
      e=avoidXSSattack(e);
        setSearchValue(e.target.value);
        const filtered =
            clients?.filter((item: any) =>
                item.reportName
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) || [];
        setFilteredData(filtered);
    };

    const getSaveDisabled = () => {
        return !userDetails?.Name || !userDetails?.Sector || !userDetails?.Country || !userDetails?.Geography || !userDetails['Technology Stack'];
    }

    const handleSubmit = () => {
        setShowSpinner(true)
        dispatch(addClient(userDetails)).then(() => {
            setToastVisible(true)
            setToastData({
                header: "Success",
                message: "Successfully added new client",
                variant: "success"
            })
            // return dispatch(getClients())
        }).then(() => setShowSpinner(false))
        setCurrentScreen('CLIENTS')
    }

    const handleDeleteClient = (data: any) => {
        setShowSpinner(true)
        console.log('data?.Name', data?.Name, data)
        dispatch(deleteClient(data?.Name)).then(() => {
            setToastVisible(true)
            setToastData({
                header: "Success",
                message: "Successfully deleted client",
                variant: "success"
            })
            // return dispatch(getClients())
        }).then(() => setShowSpinner(false))
    }

    if (currentScreen === "ADD") {
        const handleChange = (key: string, value: string | boolean) => {
            setUserDetails({
                ...userDetails,
                [key]: value,
            });
        };
        return (
            <div className="addClientsWrapper">
                <div
                    className="backNavigation"
                    onClick={() => setCurrentScreen("CLIENTS")}
                >
                    <MotifIcon
                        src={navigationIcArrowBack24px}
                        style={{ width: 20 }}
                    />
                    <span>Back</span>
                </div>
                <div className="heading">Add new client</div>
                <div className="addForm">
                    <div style={{ width: "50%", paddingRight: 16 }}>
                        <MotifFormField>
                            <span>Client Name (required)</span>
                            <Input
                                value={userDetails?.Name}
                                onChange={(e: any) =>
                                    {e=avoidXSSattack(e); handleChange("Name", e.target.value)}
                                }
                                label="Client name"
                                isError={isMaliciousInput(userDetails?.Name)}
                                errorMsg={isMaliciousInput(userDetails?.Name) ? maliciousInputErrorMsg : null}
                                maxLength={MAX_INPUT_LENGTH}
                            ></Input>
                        </MotifFormField>
                        <span>Industry Sector</span>
                        <MotifFormField>
                            <MotifLabel>Industry Sector (required)</MotifLabel>
                            <MotifSelect
                                onChange={(val: string) =>
                                    handleChange("Sector", val)
                                }
                                value={userDetails?.Sector}
                                placeholder="Select industry sector"
                            >
                                {sectors.map((sector) => (
                                    <MotifOption value={sector}>{sector}</MotifOption>
                                ))}
                            </MotifSelect>
                        </MotifFormField>
                        <span>Country (required)</span>
                        <MotifFormField>
                            <MotifLabel>Country</MotifLabel>
                            <MotifSelect
                                onChange={(val: string) =>
                                    handleChange("Country", val)
                                }
                                value={userDetails?.Country}
                                placeholder="Select country"
                            >
                                {countries.map((country) => (
                                    <MotifOption value={country}>{country}</MotifOption>
                                ))}
                            </MotifSelect>
                        </MotifFormField>
                        <span>Geographic Region (required)</span>
                        <MotifFormField>
                            <MotifLabel>Geographic Region</MotifLabel>
                            <MotifSelect
                                onChange={(val: string) =>
                                    handleChange("Geography", val)
                                }
                                value={userDetails?.Geography}
                                placeholder="Select geographic region"
                            >
                                {regions.map((region) => (
                                    <MotifOption value={region}>{region}</MotifOption>
                                ))}
                            </MotifSelect>
                        </MotifFormField>
                        <MotifFormField>
                            <span>Technology Stack</span>
                            <Input
                                value={userDetails['Technology Stack']}
                                onChange={(e: any) =>
                                    {e=avoidXSSattack(e); handleChange("Technology Stack", e.target.value)}
                                }
                                isError={isMaliciousInput(userDetails['Technology Stack'])}
                                errorMsg={isMaliciousInput(userDetails['Technology Stack']) ? maliciousInputErrorMsg : null}
                                label="Technology Stack"
                                axLength={MAX_INPUT_LENGTH}
                            ></Input>
                        </MotifFormField>
                    </div>

                    <div style={{ position: "relative", left: "20%", top: 24 }}>
                        <MotifFormField>
                            <MotifToggleSwitch
                                label="Active"
                                id="activeClientToggle"
                                value={!!userDetails?.active}
                                checked={!!userDetails?.active}
                                offLabel=""
                                onLabel={userDetails?.active ? "Yes" : "No"}
                                // onChange={() =>
                                //     handleChange("active", !userDetails?.active)
                                // }
                            ></MotifToggleSwitch>
                            <div style={{ position: 'relative', left: 48 }}>Is Active</div>
                        </MotifFormField>
                    </div>
                </div>
                <div className="addEditFormSubmit">
                    <MotifButton
                        variant="secondary"
                        stepper="prev"
                        onClick={() => setCurrentScreen("CLIENTS")}
                    >
                        Back
                    </MotifButton>
                    <MotifButton disabled={getSaveDisabled()} onClick={handleSubmit}>
                        <MotifIcon
                            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTcgM0g1Yy0xLjExIDAtMiAuOS0yIDJ2MTRjMCAxLjEuODkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJWN2wtNC00em0tNSAxNmMtMS42NiAwLTMtMS4zNC0zLTNzMS4zNC0zIDMtMyAzIDEuMzQgMyAzLTEuMzQgMy0zIDN6bTMtMTBINVY1aDEwdjR6Ii8+PC9zdmc+"
                            style={{
                                marginRight: 8,
                            }}
                            title="Icon + Text"
                        />
                        Save
                    </MotifButton>
                </div>
            </div>
        );
    }
    // console.log('filteredData', filteredData)
    return (
      <div className="clientsWrapper">
        <MotifProgressLoader show={showSpinner} />
        <div className="breadCrumbs">Clients</div>
        <div className="heading">
          <div className="title">Clients</div>
          <MotifButton onClick={() => setCurrentScreen("ADD")}>
            + Add new client
          </MotifButton>
        </div>
        <div className="clients__content">
          <MotifTabNavigation defaultActiveKey={0}>
            <MotifTabControl>My Clients</MotifTabControl>
          </MotifTabNavigation>
          <Search
            value={searchValue}
            onChange={handleSearch}
            placeholder="Search report name..."
          />
          <div className="reportLibrary__tableWrapper">
            {filteredData?.length > 0 && (
              <MotifTable
                columnDefs={[
                  {
                    field: "name",
                    headerName: "Client Name",
                    sortable: true,
                    width: 250,
                  },
                  {
                    field: "status",
                    cellRenderer: "statusCellRenderer",
                    headerName: "Status",
                    sortable: true,
                    width: 250,
                  },
                  {
                    field: "dateCreated",
                    cellRenderer: "dateCellRenderer",
                    headerName: "Date Created",
                    sortable: true,
                    width: 250,
                  },
                  {
                    field: "dateModified",
                    cellRenderer: "dateCellRenderer",
                    headerName: "Date Modified",
                    sortable: true,
                    width: 250,
                  },
                  {
                    field: "actions",
                    cellRenderer: "actionsCellRenderer",
                    headerName: "Actions",
                    sortable: true,
                    className: "testActions",
                  },
                ]}
                components={{
                  actionsCellRenderer: (p: any) => (
                    <div className="reportLibraryActions">
                      <MotifButton
                        size="small"
                        variant="text"
                        type="button"
                        onClick={() => {
                            console.log("delete", p?.data); 
                            setDeleteItemId(p?.data?.id);setDeleteModalVisible(true)}}
                      >
                        <MotifIcon
                          src={actionIcDelete24px}
                          style={{ width: 20 }}
                        />
                      </MotifButton>
                      <MotifButton
                        size="small"
                        variant="text"
                        type="button"
                        onClick={() => {}}
                      >
                        <MotifIcon
                          src={imageIcEdit24px}
                          style={{ width: 20 }}
                        />
                      </MotifButton>
                    </div>
                  ),
                  dateCellRenderer: (p: any) => (
                    <div>
                      {p.value ? new Date(p.value).toLocaleDateString() : ""}
                    </div>
                  ),
                  statusCellRenderer: (p: any) => <div>{p.value}</div>,
                }}
                onFilterChanged={function noRefCheck() {}}
                onGridReady={function noRefCheck() {}}
                onSortChanged={function noRefCheck() {}}
                rowHeight={50}
                pagination
                paginationPageSize="10"
                rowData={filteredData}
                suppressCellFocus
                suppressRowClickSelection
              />
            )}
          </div>
        </div>
        <DeleteModal
          client={
            filteredData?.find((data: any) => data.id === deleteItemId) || {}
          }
          isVisible={deleteModalVisible}
          setIsVisible={setDeleteModalVisible}
          onConfirmClick={handleDeleteClient}
        />
        <Toast
          visible={toastVisible}
          setVisible={setToastVisible}
          children={
            <div>
              <div className={"toastHeader"}>{toastData?.header}</div>
              <div className={"toastContent"}>{toastData?.message}</div>
            </div>
          }
          variant={toastData?.variant}
        />
      </div>
    );
};

export default Clients;
